import React, { memo, useEffect, useMemo, useState } from "react";
import Loader from "./loader";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import di from "../../di";
import { InView } from "react-intersection-observer";
import _ from "underscore";
let timeout;
let prevCall;
export const inViewFunc = (inView, ele, inViewCallBack, setInviewData, inViewData, sectionName, // when two callback on same screen
index) => {
    if (inViewCallBack) {
        if (sectionName) {
            if (sectionName == prevCall) {
                clearTimeout(timeout);
            }
            else {
            }
        }
        else {
            clearTimeout(timeout);
        }
        setInviewData((_list) => {
            const index = _list === null || _list === void 0 ? void 0 : _list.findIndex((x) => x === ele[inViewCallBack === null || inViewCallBack === void 0 ? void 0 : inViewCallBack.key]);
            if (inView && index === -1) {
                _list === null || _list === void 0 ? void 0 : _list.push(ele[inViewCallBack === null || inViewCallBack === void 0 ? void 0 : inViewCallBack.key]);
            }
            else {
                if (!inView && index > -1) {
                    _list === null || _list === void 0 ? void 0 : _list.splice(index, 1);
                }
            }
            return _list;
        });
        timeout = setTimeout(() => {
            inViewCallBack.callback(inViewData);
            //prevCall
        }, 100);
        prevCall = sectionName;
    }
};
const trAreEqual = (prevProps, nextProps) => {
    return (_.isEqual(prevProps.rowClassName, nextProps.rowClassName) &&
        _.isEqual(prevProps.columns, nextProps.columns) &&
        (prevProps.tableData[nextProps.keys]
            ? _.isEqual(prevProps.tableData[nextProps.keys], nextProps.ele)
            : false));
};
const TrMemoComponent = memo((props) => {
    return (React.createElement(InView, { as: "tr", onChange: (inView) => {
            if (props.inViewCallBack)
                inViewFunc(inView, props.ele, props.inViewCallBack, props.setInviewData, props.inViewData, props.sectionName);
        }, threshold: 0.5, delay: 1000, 
        // fallbackInView={true}
        trackVisibility: true, className: (props === null || props === void 0 ? void 0 : props.rowClassName)
            ? typeof (props === null || props === void 0 ? void 0 : props.rowClassName) === "string"
                ? props === null || props === void 0 ? void 0 : props.rowClassName
                : props === null || props === void 0 ? void 0 : props.rowClassName(props.ele, props === null || props === void 0 ? void 0 : props.index)
            : "", 
        // key={idx}
        onClick: () => { var _a; return (_a = props.rowOnClick) === null || _a === void 0 ? void 0 : _a.call(props, props === null || props === void 0 ? void 0 : props.ele, props === null || props === void 0 ? void 0 : props.index); } }, props.columns &&
        props.columns.length > 0 &&
        props.columns.map((cell, index) => {
            return (React.createElement(TdMemoComponent, { cell: cell, ele: props.ele, keys: index, tableData: props.tableData, trCustomFunctionOnClickoftd: cell.trCustomFunctionOnClickoftd, trCustomFunction: cell.trCustomFunction }));
        })));
}, trAreEqual);
const tdAreEqual = (prevProps, nextProps) => {
    if (prevProps.cell.keysForCustomFunction) {
        return prevProps.cell.keysForCustomFunction
            .map((ele) => {
            return (prevProps.ele[nextProps.cell[ele]] &&
                _.isEqual(prevProps.ele[nextProps.cell[ele]], nextProps.ele[nextProps.cell[ele]]));
        })
            .some((x) => x === false);
    }
    else if (prevProps.ele[nextProps.cell.key2]) {
        return (_.isEqual(prevProps.ele[nextProps.cell.key] && prevProps.ele[nextProps.cell.key], nextProps.ele[nextProps.cell.key]) &&
            _.isEqual(prevProps.ele[nextProps.cell.key2] &&
                prevProps.ele[nextProps.cell.key2], nextProps.ele[nextProps.cell.key2]));
    }
    else if (prevProps.cell.trCustomFunction) {
        return _.isEqual(prevProps.cell.trCustomFunction, nextProps.cell.trCustomFunction);
    }
    else {
        return _.isEqual(prevProps.ele[nextProps.cell.tdCustomFunction] &&
            prevProps.ele[nextProps.cell.key || nextProps.cell.sortKey] &&
            prevProps.ele[nextProps.cell.key || nextProps.cell.sortKey], nextProps.ele[nextProps.cell.key || nextProps.cell.sortKey]);
    }
};
const TdMemoComponent = memo((props) => {
    var _a, _b, _c, _d;
    return (React.createElement("td", { key: props.keys, className: props.cell.columnClassName, onClick: (e) => {
            var _a;
            ((_a = props.cell) === null || _a === void 0 ? void 0 : _a.trCustomFunctionOnClickoftd) &&
                props.cell.trCustomFunctionOnClickoftd(e, props.ele);
        } },
        ((_a = props.cell) === null || _a === void 0 ? void 0 : _a.tdCustomFunction) && !props.cell.keysForCustomFunction
            ? (_b = props.cell) === null || _b === void 0 ? void 0 : _b.tdCustomFunction(props.ele[`${props.cell.key}`], props.cell.key2 ? props.ele[`${props.cell.key2}`] : null)
            : props.ele[`${props.cell.key}`],
        ((_c = props.cell) === null || _c === void 0 ? void 0 : _c.tdCustomFunction) &&
            props.cell.keysForCustomFunction &&
            ((_d = props.cell) === null || _d === void 0 ? void 0 : _d.tdCustomFunction(props.cell.keysForCustomFunction.map((keyName) => props.ele[keyName]))),
        props.cell.trCustomFunction && props.cell.trCustomFunction(props.ele)));
}, tdAreEqual);
const thAreEqual = (prevProps, nextProps) => {
    return _.isEqual(prevProps, nextProps);
};
const ThMemoComponent = memo((props) => {
    // console.log(
    //   //JSON.parse(e.data).response.data.lut,
    //   "lastupdted",
    //   new Date().toTimeString(),
    //   props
    // );
    return (React.createElement("th", { id: "reports-th", key: props.idx, className: props.tableHead.columnClassName ? props.tableHead.columnClassName : "", onMouseEnter: () => props.handleHover(props.tableHead, props.idx, "ENTER"), onMouseLeave: () => props.handleHover(props.tableHead, props.idx, "EXIT") }, props.tableHead.arrows ? (React.createElement("div", { className: "title" },
        React.createElement("div", { className: `d-flex align-items-center ${props.tableHead.onlyOneArrowAtaTime &&
                props.sortingAppliedForColoumn[props.idx]
                ? "DMSansMedium_12_500 txt-midnight-blue"
                : ""} ${props.tableHead.arrowClassName
                ? props.tableHead.arrowClassName
                : ""}` },
            React.createElement("label", null, props.tableHead.columnName),
            React.createElement("div", { className: "arrows", onClick: () => {
                    var _a;
                    if (props.tableHead.applySorting) {
                        props === null || props === void 0 ? void 0 : props.setSortingKey(props.tableHead.key
                            ? props.tableHead.key
                            : (_a = props.tableHead) === null || _a === void 0 ? void 0 : _a.sortKey, props.tableHead.type);
                        if (props.tableHead.onlyOneArrowAtaTime) {
                            props.setSortingAppliedForColoumn((prevState) => prevState.map((x, id) => {
                                if (props.idx === id)
                                    x = true;
                                else
                                    x = false;
                                return x;
                            }));
                            props.setUparrow((prevState) => {
                                return prevState.map((x, id) => {
                                    if (id === props.idx)
                                        x = !x;
                                    return x;
                                });
                            });
                        }
                    }
                    else {
                        null;
                    }
                } }, props.tableHead.onlyOneArrowAtaTime ? (React.createElement("div", { className: `arrow-at-a-time ${props.hoveredOn[props.idx] ||
                    props.sortingAppliedForColoumn[props.idx]
                    ? "visible"
                    : "invisible"} ` },
                props.upArrow[props.idx] && (React.createElement("i", { className: "edel-icon-arrow-down" })),
                !props.upArrow[props.idx] && (React.createElement("i", { className: "edel-icon-arrow-down down" })))) : (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "edel-icon-caret-up" }),
                React.createElement("i", { className: "edel-icon-caret-down" }))))))) : (React.createElement("label", null, props.tableHead.columnName))));
}, thAreEqual);
const ReportsGenericTable = (props) => {
    // const [tableData, setTableData] = useState<any>([]);
    const [sortingType, setSortingType] = useState(false);
    const [sortingKey, setSortingKey] = useState(undefined);
    // const [dataType, setDataType] = useState<string>();
    const [inViewData, setInviewData] = useState([]);
    const [sortingAppliedForColoumn, setSortingAppliedForColoumn] = useState(new Array(props.columns.length).fill(false));
    const [hoveredOn, setHoveredOn] = useState(new Array(props.columns.length).fill(false));
    const [upArrow, setUparrow] = useState(new Array(props.columns.length).fill(false));
    const sortedData = useMemo(() => {
        var _a;
        return (props === null || props === void 0 ? void 0 : props.applyExternalSort)
            ? props === null || props === void 0 ? void 0 : props.data
            : (_a = di === null || di === void 0 ? void 0 : di.common) === null || _a === void 0 ? void 0 : _a.getSortedData(props === null || props === void 0 ? void 0 : props.data, sortingType, sortingKey === null || sortingKey === void 0 ? void 0 : sortingKey.key, sortingKey === null || sortingKey === void 0 ? void 0 : sortingKey.dataType);
    }, [sortingKey, props === null || props === void 0 ? void 0 : props.data]);
    const handleHover = (tableHead, idx, enterOrExit) => {
        if (tableHead.applySorting)
            switch (enterOrExit) {
                case "ENTER":
                    setHoveredOn((prevState) => prevState.map((x, id) => {
                        if (id === idx)
                            x = true;
                        else
                            x = false;
                        return x;
                    }));
                    break;
                case "EXIT":
                    setHoveredOn((prevState) => prevState.map((x, id) => {
                        if (id === idx && !upArrow[id])
                            x = false;
                        if (id === idx && upArrow[id])
                            x = true;
                        return x;
                    }));
                    break;
            }
    };
    useEffect(() => {
        setHoveredOn(new Array(props.columns.length).fill(false));
    }, [props.columns.length]);
    return props.loader ? (props.shimmer ? (props.shimmer) : (React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `generic-table ${props.parentClassName ? props.parentClassName : ""}` },
            React.createElement("table", { className: props.tableClassName ? props.tableClassName : "" },
                React.createElement("thead", null,
                    React.createElement("tr", { className: props.hideHeader ? "d-none" : "" }, props.columns &&
                        props.columns.map((tableHead, idx) => {
                            return (React.createElement(ThMemoComponent, { tableHead: tableHead, idx: idx, 
                                // applySortingAccordingKey={applySortingAccordingKey}
                                setSortingKey: (key, dataType) => {
                                    setSortingType((order) => {
                                        (props === null || props === void 0 ? void 0 : props.applyExternalSort)
                                            ? props === null || props === void 0 ? void 0 : props.applyExternalSort(key, dataType, order)
                                            : setSortingKey({ key, dataType });
                                        return !order;
                                    });
                                }, columns: props.columns, setSortingType: setSortingType, handleHover: handleHover, sortingAppliedForColoumn: sortingAppliedForColoumn, hoveredOn: hoveredOn, upArrow: upArrow, setSortingAppliedForColoumn: setSortingAppliedForColoumn, setUparrow: setUparrow }));
                        }))), props === null || props === void 0 ? void 0 :
                props.titleBeforeTr,
                React.createElement("tbody", null,
                    (props === null || props === void 0 ? void 0 : props.data) &&
                        (props === null || props === void 0 ? void 0 : props.data.length) > 0 &&
                        (sortingKey
                            ? sortedData === null || sortedData === void 0 ? void 0 : sortedData.map((ele, idx) => {
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(TrMemoComponent, { ele: ele, index: idx, tableData: sortedData, inViewCallBack: props.inViewCallBack, setInviewData: setInviewData, inViewData: inViewData, rowClassName: props.rowClassName, key: idx, columns: props.columns, keys: idx, rowOnClick: props.rowOnClick, sectionName: props.sectionName })));
                            })
                            : props === null || props === void 0 ? void 0 : props.data.map((ele, idx) => {
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(TrMemoComponent, { ele: ele, tableData: props === null || props === void 0 ? void 0 : props.data, inViewCallBack: props.inViewCallBack, setInviewData: setInviewData, inViewData: inViewData, rowClassName: props.rowClassName, key: idx, index: idx, columns: props.columns, keys: idx, rowOnClick: props.rowOnClick, sectionName: props.sectionName })));
                            })),
                    props.message && props.message.show && (React.createElement("tr", null,
                        React.createElement("td", { colSpan: 30, className: props.messageShowClass && "messageShowClass" },
                            React.createElement(Errormsg, { customMsg: props.customMsg, icon: props.message.icon, msg: props.message.msg, paths: props.paths })))))))));
};
export default ReportsGenericTable;
